import Vue from 'vue';
import 'swiper/css/swiper.min.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';

Vue.use(VueAwesomeSwiper);
